import { Box, Grid, Text } from '@chakra-ui/react';
import { ProductSuggestionsData } from '@diamond/shared/types';
import { useShipToStore } from '@diamond/sol-buyer-context';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import shallow from 'zustand/shallow';

import { CardProduct } from '../common';

interface VoucherRelatedProductsProps {
  data: ProductSuggestionsData;
  title?: string;
  maxProducts?: number;
  section?: string;
  pageName?: string;
}

export const VoucherRelatedProducts = ({
  data,
  title = 'Produk Terkait',
  maxProducts = 2,
  section,
  pageName,
}: VoucherRelatedProductsProps) => {
  const [selectedShipToId] = useShipToStore(
    (s) => [s.selectedShipToId],
    shallow
  );
  const { push } = useRouter();

  const productsData = useMemo(() => (data !== undefined ? data : []), [data]);

  const displayProducts = useMemo(
    () => productsData.slice(0, maxProducts),
    [productsData, maxProducts]
  );

  const handleClickProductCard = (productId: string) => {
    push({
      pathname: `/product/${productId}`,
      query: { warehouse: selectedShipToId },
    });
  };

  if (productsData.length === 0) {
    return null;
  }

  return (
    <Box>
      <Text
        fontSize={{ base: '16px', md: '18px' }}
        fontWeight="medium"
        color="#000000"
        mb="16px"
      >
        {title}
      </Text>
      <Grid gridTemplateColumns="repeat(2, 1fr)" gap="16px">
        {displayProducts.map((val, idx) => {
          const price = val.prices.length > 0 ? val.prices[0].price : 0;
          return (
            <Box key={idx}>
              <CardProduct
                productId={val.id}
                imageUrl={val.product_images_medium?.[0]}
                productName={val.brand_desc}
                itemCode={val.item_code}
                price={price}
                unit={val.pack_unit}
                description={val.title}
                measurement_unit={val.sales_unit}
                name="product"
                navigateTo={{
                  pathname: `/product/${val.id}`,
                  query: { warehouse: selectedShipToId },
                }}
                onClickTambahKeranjang={() => {
                  handleClickProductCard(val.id);
                }}
                stockStatus={
                  val.stock_status ||
                  (val.stock > 0 ? 'AVAILABLE' : 'OUT_OF_STOCK')
                }
                stock={val.stock}
                product={val}
                section={section}
                page={pageName}
              />
            </Box>
          );
        })}
      </Grid>
    </Box>
  );
};
